var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrafts24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9894 9.50164C22.9895 8.78164 22.6195 8.15161 22.0496 7.80156L13 2.50082L3.94957 7.80008C3.37954 8.15003 2.99949 8.78 2.99943 9.5L2.99861 19.5C2.99852 20.6 3.89844 21.5001 4.99844 21.5002L20.9984 21.5015C22.0984 21.5016 22.9985 20.6016 22.9986 19.5016L22.9894 9.50164ZM20.9894 9.50147L20.9894 9.51147L12.999 14.5008L4.99943 9.50016L12.9998 4.82082L20.9894 9.50147ZM4.99923 11.8402L4.99861 19.5002L20.9986 19.5015L20.9892 11.8715L12.9988 16.8608L4.99923 11.8402Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafts24Px);
export default __webpack_public_path__ + "static/media/drafts_24px.0eca3dec0c9ee8bb8e096f6a9ce09e5a.svg";
export { ForwardRef as ReactComponent };